import React from 'react';
import { useAdminAuth } from '@/contexts/AdminAuthContext';
import { AdminLogin } from './AdminLogin';
import { InvitationManager } from './InvitationManager';
import { Loader2 } from 'lucide-react';

export const AdminPage: React.FC = () => {
  const { isAuthenticated, loading, login } = useAdminAuth();

  if (loading) {
    console.log('AdminPage: Loading...');
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex items-center gap-2">
          <Loader2 className="w-6 h-6 animate-spin" />
          <span>Loading...</span>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('not isAuthenticated');
    return <AdminLogin onLoginSuccess={login} />;
  }

  console.log('isAuthenticated');
  return <InvitationManager />;
};
